import {Typography} from '~library/atoms/Typography';
import {SparkleIcon} from '~library/svg/SparkleIcon';

import './MobileBox.sass';

export const MobileBox = ({children, animated = false}) => (
  <div className="mobile-box">
    {animated && (
      <div className="mobile-box__header right">
        <div className="mobile-box__header__right">
          <SparkleIcon ratio={0.75} className="background-editor__svg" />
          <Typography variant="paragraph4" size="medium" color="tanzanite">
            Animated
          </Typography>
        </div>
      </div>
    )}
    <div className="mobile-box__body">{children}</div>
  </div>
);
